import {put, takeLatest, call} from 'redux-saga/effects';
import * as venueService from "../../../services/venueService";
import {
    UPDATE_VENUE_DELIVERYAREAS,
    UPDATE_VENUE_DELIVERYAREAS_SUCCESS,
    UPDATE_VENUE_DELIVERYAREAS_ERROR,
}
    from "../../actions/venue";

function* updateVenueDeliveryAreasSaga(action) {
    try {
       const data  = yield call(venueService.UpdateVenueDeliveryAreas,action.payload)
        
       yield put({
        type: UPDATE_VENUE_DELIVERYAREAS_SUCCESS,
        payload: data
    });


    } catch (error) {
        yield put({
            type: UPDATE_VENUE_DELIVERYAREAS_ERROR,error: error.data
        });
    }
}


export function* updateVenueDeliveryAreasSagaWatcher() {
    yield takeLatest(UPDATE_VENUE_DELIVERYAREAS, updateVenueDeliveryAreasSaga);
}